// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"z4-z","colorTextValue":"A4-z","swatches":"B4-z","collapseLink":"C4-z","isCollapsed":"D4-z","dropdown":"E4-z","disabled":"F4-z"};